import { render, staticRenderFns } from "./searchView.vue?vue&type=template&id=545a7a32&scoped=true&"
import script from "./searchView.vue?vue&type=script&lang=js&"
export * from "./searchView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545a7a32",
  null
  
)

export default component.exports